import React from "react";
import { useLocation } from "react-router-dom";
import "./Order_id_holder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleDown } from "@fortawesome/free-regular-svg-icons";
import { formatDateTime } from "../../../../utils/common";
// import Return_Lottie from "../../../Animation/return_Lottie/Return_Lottie";

function Order_id_holder({ order, headingText, subText }) {
  const location = useLocation();
  const isReturnPage = location.pathname === "/return-order-details";

const handleDownloadInvoice = async (invoicePath) => {
  if (!invoicePath) {
    alert("Invoice not available");
    return;
  }

  try {
    const fileUrl = `${process.env.REACT_APP_IMAGE_URL}${invoicePath}`;
    const response = await fetch(fileUrl);

    

    if (!response.ok) {
      alert("File not found on server");
      return;
    }

    const blob = await response.blob();

    if (blob.type !== "application/pdf") {
      alert("Server did not return a valid PDF");
      return;
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Invoice.pdf";
    link.click();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Download failed:", error);
    alert("Failed to download invoice");
  }
};

  return (
    <>
      <section className="Order_id_holder">
        <div className="order_id">
          <div className="img_id_holder">
            {!isReturnPage && (
              <div>
                <div className="img_holder">
                  <img
                    className="Product_img"
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/favicon.jpg"
                    }
                    alt="Product_img"
                  />
                </div>
              </div>
            )}

            {isReturnPage && (
              <div className="animation_holder">{/* <Return_Lottie /> */}</div>
            )}

            <div className="ms-3">
              <h2>{headingText}</h2>
              <p className="sub_text">{subText}</p>
            </div>
          </div>

          <p>{formatDateTime(order?.createdAt)}</p>
        </div>

        <>
          {" "}
          <div className="mt-3 ms-2">
            {/* <h6 className="odh6">
                Selected Delivery Date:{" "}
                <span className="small">
                  2025-09-09
                </span>
              </h6> */}
          </div>
          {/* <div className="ms-2">
              <h6 className="odh6">
                Selected Delivery Time:
                <span className="small">
                  10:00 PM -
                  12:00 PM
                </span>
              </h6>
            </div> */}
          <div
            className="ms-2 mb-2"
            onClick={() => handleDownloadInvoice(order?.invoice)}
          >
            <button className="download_btn">
              Download Invoice <FontAwesomeIcon icon={faCircleDown} />
            </button>
          </div>
        </>
      </section>
    </>
  );
}

export default Order_id_holder;
